import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { WhatsNewService } from '../../modules/tandem-core/services/whats-new.service';
import { Release } from '../../modules/admin/models/release';

@Component({
  selector: 'tandem-whats-new-banner',
  templateUrl: './whats-new-banner.component.html',
  styleUrls: ['./whats-new-banner.component.scss']
})
export class WhatsNewBannerComponent implements OnInit, OnDestroy {
  @Output() openModal = new EventEmitter<void>();

  showBanner = false;
  latestRelease: Release | null = null;

  private subscription?: Subscription;

  constructor(private whatsNewService: WhatsNewService) {}

  ngOnInit(): void {
    this.subscription = this.whatsNewService.state$.subscribe(state => {
      this.showBanner = state.hasNewRelease;
      this.latestRelease = state.latestRelease;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onViewClick(): void {
    this.openModal.emit();
  }

  onDismiss(): void {
    if (this.latestRelease) {
      this.whatsNewService.acknowledgeRelease(this.latestRelease.version);
    }
    this.showBanner = false;
  }
}
